import React from 'react';
import dynamic from 'next/dynamic';
import { FallbackLoader } from '@/components/fallbackLoader';

export const ScoresDrawerContent = dynamic(
  () => import('./scoresDrawer').then((mod) => mod.ScoresDrawerContent),
  {
    ssr: false,
    loading: (loadingProps) => (
      <FallbackLoader fallbackProps={loadingProps} minWidth={360} />
    )
  }
);

export const ScSuggestionDrawerContent = dynamic(
  () =>
    import('./scSuggestionDrawer').then((mod) => mod.ScSuggestionDrawerContent),
  {
    ssr: false,
    loading: (loadingProps) => (
      <FallbackLoader fallbackProps={loadingProps} minWidth={360} />
    )
  }
);

export const MedicationDrawerContent = dynamic(
  () => import('./medicationDrawer').then((mod) => mod.MedicationDrawerContent),
  {
    ssr: false,
    loading: (loadingProps) => (
      <FallbackLoader fallbackProps={loadingProps} minWidth={360} />
    )
  }
);

export const PremedicationDrawerContent = dynamic(
  () =>
    import('./premedicationDrawer').then(
      (mod) => mod.PremedicationDrawerContent
    ),
  {
    ssr: false,
    loading: (loadingProps) => (
      <FallbackLoader fallbackProps={loadingProps} minWidth={360} />
    )
  }
);

export const ProtocolDrawerContent = dynamic(
  () => import('./protocolDrawer').then((mod) => mod.ProtocolDrawerContent),
  {
    ssr: false,
    loading: (loadingProps) => (
      <FallbackLoader fallbackProps={loadingProps} minWidth={360} />
    )
  }
);

export const TemplatesDrawerContent = dynamic(
  () => import('./templatesDrawer').then((mod) => mod.TemplatesDrawerContent),
  {
    ssr: false,
    loading: (loadingProps) => (
      <FallbackLoader fallbackProps={loadingProps} minWidth={360} />
    )
  }
);

export const NewPatientDrawerContent = dynamic(
  () => import('./newPatientDrawer').then((mod) => mod.NewPatientDrawerContent),
  {
    ssr: false,
    loading: (loadingProps) => (
      <FallbackLoader fallbackProps={loadingProps} minWidth={360} />
    )
  }
);

export const EpicDocumentsDrawerContent = dynamic(
  () =>
    import('./epicDocumentsDrawer').then(
      (mod) => mod.EpicDocumentsDrawerContent
    ),
  {
    ssr: false,
    loading: (loadingProps) => (
      <FallbackLoader fallbackProps={loadingProps} minWidth={360} />
    )
  }
);

export const MedicationInstructionsDrawerContent = dynamic(
  () =>
    import('./medicationInstructionsDrawer').then(
      (mod) => mod.MedicationInstructionsDrawerContent
    ),
  {
    ssr: false,
    loading: (loadingProps) => (
      <FallbackLoader fallbackProps={loadingProps} minWidth={360} />
    )
  }
);

export const PatientsAppDetailsDrawerContent = dynamic(
  () =>
    import('./patientsAppDetailsDrawer').then(
      (mod) => mod.PatientsAppDetailsDrawerContent
    ),
  {
    ssr: false,
    loading: (loadingProps) => (
      <FallbackLoader fallbackProps={loadingProps} minWidth={360} />
    )
  }
);

export const CustomDocumentDrawerContent = dynamic(
  () =>
    import('./customDocumentDrawer').then(
      (mod) => mod.CustomDocumentDrawerContent
    ),
  {
    ssr: false,
    loading: (loadingProps) => (
      <FallbackLoader fallbackProps={loadingProps} minWidth={500} />
    )
  }
);

export const BillingPatientDrawerContent = dynamic(
  () =>
    import('./billingPatientDrawer').then(
      (mod) => mod.BillingPatientDrawerContent
    ),
  {
    ssr: false,
    // Matches the loaded content's `md` width, so the drawer does not resize under the
    // user when the chunk resolves.
    loading: (loadingProps) => (
      <FallbackLoader fallbackProps={loadingProps} minWidth={560} />
    )
  }
);
